(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utilities = require('./utilities');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

jQuery(document).ready(function ($) {

  // 09A Brackets A - button styles dependent on link type
  $(document).ready(function () {
    $('.builder-type-09a-brackets').each(function () {
      var wrapper = $(this).find('.air-link-types').parents('.control-row-2');
      if ($(this).find('.air-link-types:checked').val() == 'a') {
        wrapper.next().next().find('.air-link-styles').find('option[value="secondary"]').hide();
      }
    });
  });
  $(document).on('change', '.air-link-types', function () {
    var wrapper = $(this).parents('.control-row-2');

    if ($(this).prop('checked') == true) {
      if ($(this).val() == 'a') {
        wrapper.next().next().find('.air-link-styles').find('option[value="secondary"]').hide();
      } else {
        wrapper.next().next().find('.air-link-styles').find('option[value="secondary"]').show();
      }
    }
  });

  /*
  ==========================================================================
  nav items
  ==========================================================================
  */
  var contentTypeSelector = '.appearance_page_theme_options [name*="[content_type]"]',
      $contentType = $(contentTypeSelector),
      useHoverTabsSelector = '.appearance_page_theme_options [type="checkbox"][name*="[use_hover_tabs]"]',
      $useHoverTabs = $(useHoverTabsSelector);

  $(document).ready(function () {
    $contentType.each(function () {
      $(this).wrapperRadioList().loadContentTypeField();
    });
    $useHoverTabs.showHideHoverTabs();
  });
  $(document).on('change', contentTypeSelector, function () {
    $(this).wrapperRadioList().loadContentTypeField();
  });
  $(document).on('change', useHoverTabsSelector, function () {
    $(this).showHideHoverTabs();
  });
  TypeRocket.repeaterCallbacks.push(function ($template) {
    if ($template.data('id') == 'children') {
      setTimeout(function () {
        $template.find('[name*="[content_type]"]').wrapperRadioList().loadContentTypeField();
        $(useHoverTabsSelector).showHideHoverTabs();
      }, 1);
    }
  });

  $.fn.extend({
    loadContentTypeField: function loadContentTypeField() {
      var $this = $(this),
          val = $this.find('[type="radio"]:checked').val(),
          $wrapper = $this.wrapperRepeaterRow(),
          $category = $wrapper.find('[name*="[post_category]"]').wrapperElement(),
          $tag = $wrapper.find('[name*="[post_tag]"]').wrapperElement(),
          $search = $wrapper.find('[name*="[post_search]"]').wrapperElement(),
          $pageImage = $wrapper.find('[name*="[page_image]"]').wrapperElement(),
          $all = $category.add($tag).add($search).add($pageImage);
      $all.hide();
      if (val == 'Post Category') {
        $category.show();
      } else if (val == 'Post Tag') {
        $tag.show();
      } else if (val == 'Post Search') {
        $search.show();
      } else if (val == 'Page') {
        $pageImage.show();
      }
    },
    showHideHoverTabs: function showHideHoverTabs() {
      $(this).each(function () {
        var $this = $(this),
            $wrapper = $this.wrapperRepeaterRow(),
            $ctas = $wrapper.find('.tr-repeater-group-template[data-id="ctas"]').wrapperElement(),
            $ctasHeadline = $wrapper.find('[name*="[ctas_headline]"]').wrapperElement(),
            $children = $wrapper.find('.tr-repeater-group-template[data-id="children"]').next().find('.tr-repeater-group'),
            $all = $ctas.add($ctasHeadline);
        $all.hide();
        if ($this.prop('checked') == false) {
          $ctas.show();
          $ctasHeadline.show();
        }
        $children.each(function (index, item) {
          var $item = $(item),
              $contentType = $item.find('[name*="[content_type]"]').wrapperElement(),
              $grandchildren = $item.find('.tr-repeater-group-template[data-id="grandchildren"]').wrapperElement(),
              $grandchildrenHeadline = $item.find('[name*="[grandchildren_headline]"]').wrapperElement(),
              $all = $contentType.add($grandchildren).add($grandchildrenHeadline);
          $all.hide();
          if ($this.prop('checked') == true) {
            $grandchildrenHeadline.show();
            $contentType.show();
          } else {
            $grandchildren.show();
          }
        });
      });
    },
    wrapperElement: function wrapperElement() {
      return $(this).parents('[class*="typerocket-elements"]').first();
    },
    wrapperRepeaterRow: function wrapperRepeaterRow() {
      return $(this).parents('.tr-repeater-group').first();
    },
    wrapperRadioList: function wrapperRadioList() {
      return $(this).parents('ul').first();
    }
  });
});

/*
==========================================================================
conditional logic api
==========================================================================
*/

var ConditionalLogic = function (_AirstreamClass) {
  _inherits(ConditionalLogic, _AirstreamClass);

  _createClass(ConditionalLogic, [{
    key: 'initializeChangingFields',


    /**
     * [initializeChangingFields description]
     * @return {null}
     */
    value: function initializeChangingFields() {
      var $template = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;


      var $conditions = this.$scope.find('[data-conditions]');

      if ($template && !$template.target) $conditions = $template.find('[data-conditions]');

      $conditions.each(function (index, item) {
        jQuery(function ($) {
          if (!$(item).data('conditional-name') && $(item).attr('name')) {
            $(item).attr('data-conditional-name', $(item).attr('name') + '[' + index + ']');
          }

          var conditions = $(item).getConditions(),
              $wrapper = $(item).getOuterWrapper();

          for (var c in conditions) {

            var rules = conditions[c];

            for (var r in rules) {

              var condition = rules[r],
                  $field = $wrapper.find('[name*="[' + condition.field + ']"]'),
                  conditionalFields = $field.data('conditional-fields') ? $field.data('conditional-fields') : [];

              conditionalFields.push($(item).data('conditional-name'));

              $field.addClass('has-conditional-fields').data('conditional-fields', conditionalFields);
            }
          }
        });
      });

      setTimeout(function () {
        jQuery('.has-conditional-fields').each(function () {
          jQuery(this).trigger('change');
        });
      }, 10);
    }

    /**
     * show/hide conditional fields
     * @param  {event} e
     * @return {null}
     */

  }, {
    key: 'toggleFields',
    value: function toggleFields(e) {

      var $this = jQuery(e.currentTarget),
          conditionalFields = $this.data('conditional-fields');

      for (var i in conditionalFields) {

        var $conditionalField = jQuery('[data-conditional-name="' + conditionalFields[i] + '"]'),
            conditions = $conditionalField.getConditions();

        this.hideField($conditionalField);

        for (var c in conditions) {
          var rules = conditions[c];
          if (this.conditionsMet($this.getOuterWrapper(), rules)) {
            this.showField($conditionalField);
          }
          this.toggleTab($conditionalField.getFieldWrapper());
        }
      }
    }

    /**
     * [hideField description]
     * @param  {jQuery object} $field
     * @return {null}
     */

  }, {
    key: 'hideField',
    value: function hideField($field) {
      $field.getFieldWrapper().hide();
      $field.data('required', $field.prop('required'));
      $field.attr('name', '');
      $field.prop('required', false);
    }

    /**
     * [showField description]
     * @param  {jQuery object} $field
     * @return {null}
     */

  }, {
    key: 'showField',
    value: function showField($field) {
      $field.getFieldWrapper().show();
      $field.attr('name', $field.data('conditional-name').replace(/\[\d+\]$/, ''));
      $field.prop('required', $field.data('required'));
    }

    /**
     * [conditionsMet description]
     * @param  {jQuery object} $field
     * @param  {array} rules
     * @return {boolean}
     */

  }, {
    key: 'conditionsMet',
    value: function conditionsMet($wrapper, rules) {
      var met = 0;
      for (var i in rules) {
        var condition = rules[i],
            $field = $wrapper.find('[name*="[' + condition.field + ']"]'),

        // operator = condition.operator,
        value = condition.value;
        if ($field.length && this.conditionMet($field, value)) {
          met++;
        }
      }
      return met == rules.length;
    }

    /**
     * [conditionMet description]
     * @param  {jQuery object} $field
     * @param  {string} value
     * @return {boolean}
     */

  }, {
    key: 'conditionMet',
    value: function conditionMet($field, value) {
      var type = $field.attr('type'),
          tagName = $field.prop('tagName');
      if (type == 'checkbox' || type == 'radio') {
        if ($field.filter(':checked').val() == value) {
          return true;
        } else if (type == 'checkbox' && $field.prop('checked')) {
          return true;
        }
      } else if (tagName.toLowerCase() == 'select') {
        if ($field.find(':selected').val() == value) {
          return true;
        }
      }
      return false;
    }

    /**
     * [toggleTab description]
     * @param  {jQuery object} $wrapper
     * @return {null}
     */

  }, {
    key: 'toggleTab',
    value: function toggleTab($wrapper) {
      var $tab = $wrapper.parents('.tab-section').first(),
          $tabLink = jQuery('a[href="#' + $tab.attr('id') + '"]').parent(),
          $visibleElements = $tab.find('> div').filter(function () {
        return jQuery(this).css('display') != 'none';
      });

      $tabLink.hide();
      if ($visibleElements.length) $tabLink.show();
    }

    /**
     * [init description]
     * @return {null}
     */

  }, {
    key: 'init',
    value: function init() {
      jQuery(window).on('load', this.initializeChangingFields.bind(this));

      jQuery(document).on('change', '.has-conditional-fields', this.toggleFields.bind(this));

      TypeRocket.repeaterCallbacks.push(this.initializeChangingFields.bind(this));
    }

    /**
     * [constructor description]
     * @param {string} scope
     */

  }]);

  function ConditionalLogic(scope) {
    _classCallCheck(this, ConditionalLogic);

    var _this = _possibleConstructorReturn(this, (ConditionalLogic.__proto__ || Object.getPrototypeOf(ConditionalLogic)).call(this, scope));

    _this.init();
    return _this;
  }

  return ConditionalLogic;
}(_utilities.AirstreamClass);

jQuery.fn.extend({
  getConditions: function getConditions() {
    return JSON.parse(jQuery(this).data('conditions').replace(/'/g, '"'));
  },
  getFieldWrapper: function getFieldWrapper() {
    return jQuery(this).parents('[class*="typerocket-elements-fields"]').first();
  },
  getOuterWrapper: function getOuterWrapper() {
    return jQuery(this).parents('.tr-repeater-group, [id*="tab-panel"], .builder-field-group, .postbox-container').first();
  }
});

jQuery(document).ready(function () {
  new ConditionalLogic('body');
});

},{"./utilities":2}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
==========================================================================
utility functions
==========================================================================
*/
function getCookie(name) {
  var value = '; ' + document.cookie;
  var parts = value.split('; ' + name + '=');
  if (parts.length == 2) return parts.pop().split(';').shift();
}

function setCookie(name, value, days) {
  var date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  var expires = '; expires=' + date.toGMTString();
  document.cookie = name + '=' + value + expires + ';path=/';
}

function getParam(p) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.search;

  var match = RegExp('[?&]' + p + '=([^&]*)').exec(url);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

function getParams() {
  var query = window.location.search;

  return query ? (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce(function (params, param) {
    var _param$split = param.split('='),
        _param$split2 = _slicedToArray(_param$split, 2),
        key = _param$split2[0],
        value = _param$split2[1];

    params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
    return params;
  }, {}) : false;
}

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function superscript() {
  jQuery(function ($) {
    jQuery('p,h1,h2,h3,h4,h5,h6,li,a,span,td,th,i,b,u,em,strong,del,label,small').contents().filter(function () {
      return this.nodeType === 3;
    }).replaceWith(function () {
      return this.nodeValue.replace(/[®™️]/g, '<sup>$&</sup>');
    });
  });
}

function urlDecode(str) {
  return decodeURIComponent((str + '').replace(/\+/g, '%20'));
}

/*
==========================================================================
class utility
==========================================================================
*/

var AirstreamClass = function () {
  _createClass(AirstreamClass, [{
    key: 'addListeners',


    /*
    ==========================================================================
    listeners
    ==========================================================================
    */
    value: function addListeners() {
      for (var selector in this.listeners) {
        this.addListener(selector, this.listeners[selector]);
      }
    }
  }, {
    key: 'addListener',
    value: function addListener(selector, listener) {
      if (listener instanceof Array) {
        for (var item in listener) {
          if (!listener.hasOwnProperty(item)) continue;
          this.addListener(selector, listener[item]);
        }
      } else {
        this[selector].on(listener.ev, this[listener.func].bind(this));
      }
    }

    /*
    ==========================================================================
    selectors
    ==========================================================================
    */

  }, {
    key: 'addSelectors',
    value: function addSelectors() {
      for (var name in this.selectors) {
        this.addSelector(name, this.selectors[name]);
      }
    }
  }, {
    key: 'addSelector',
    value: function addSelector(name, selector) {
      this['$' + name] = this.$scope.find(selector);
    }

    /*
    ==========================================================================
    init
    ==========================================================================
    */

  }]);

  function AirstreamClass(scope) {
    _classCallCheck(this, AirstreamClass);

    this.$scope = jQuery(scope);
  }

  return AirstreamClass;
}();

/*
==========================================================================
export
==========================================================================
*/


exports.getCookie = getCookie;
exports.setCookie = setCookie;
exports.getParam = getParam;
exports.getParams = getParams;
exports.debounce = debounce;
exports.superscript = superscript;
exports.urlDecode = urlDecode;
exports.AirstreamClass = AirstreamClass;

},{}]},{},[1]);
